// @ts-nocheck
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "tss-react/mui";
import { isIosMobileBrowser } from "../../../../base/environment/utils";
import Icon from "../../../../base/icons/components/Icon";
import { IconCopy, IconEnvelope, IconGoogle, IconOffice365, IconYahoo, 
// CUSTOM
IconArrowDownSmall,
// END
 } from "../../../../base/icons/svg";
// eslint-disable-next-line lines-around-comment
// @ts-ignore
import { copyText } from "../../../../base/util/copyText.web";
// CUSTOM
var url = window.location.href.replace(/\/$/, "");
import Config from "../../../../customise/config";
const { socket_endpoint } = Config;
import Button from "@atlaskit/button";
import Spinner from "@atlaskit/spinner";
import axios from "axios";
import Toast from "react-simple-toasts";
import { Constant, CURRENT_ROOM_NAME } from "../../../../webjam/constant";
var lastSeg = CURRENT_ROOM_NAME;
import { apiVersion } from "../../../../customise/welcome-dashboard/Utils";
import { sendAnalytics } from "../../../../analytics";
import { isIpad, isMobileBrowserC, isSocialMobileApp, } from "../../../../customise/Utils";
import InputMask from "react-input-mask";
import config from "../../../../customise/config";
import { CustomMuiTooltip } from "../../../../base/tooltip/components/TooltipWrapper";
import { checkSubscription, ct } from "../../../../customise/constant-Utils";
import { handleSubscription } from "../../../../customise/custom/components/CommonComponents";
const useStyles = makeStyles()((theme) => {
    return {
        container: {
            marginTop: theme.spacing(4),
        },
        label: {
            marginBottom: theme.spacing(2),
        },
        iconRow: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
        },
        iconContainer: {
            display: "block",
            padding: theme.spacing(2),
            cursor: "pointer",
        },
    };
});
/**
 * Component that renders email invite options.
 *
 * @returns {ReactNode}
 */
// CUSTOM
// function InviteByEmailSection({ inviteSubject, inviteText, inviteTextiOS }: IProps) {
function InviteByEmailSection({ inviteSubject, inviteText, inviteTextiOS, inviteUrl, }) {
    // END
    const { classes } = useStyles();
    const { t } = useTranslation();
    const encodedInviteSubject = encodeURIComponent(inviteSubject);
    const encodedInviteText = encodeURIComponent(inviteText);
    const encodedInviteTextiOS = encodeURIComponent(inviteTextiOS);
    const encodedDefaultEmailText = isIosMobileBrowser()
        ? encodedInviteTextiOS
        : encodedInviteText;
    // CUSTOM
    const [fields, setFields] = useState({
        email: "",
        number: "",
        isEmailLoading: false,
        isTextLoading: false,
    });
    const [emailSent, setEmailSent] = useState("");
    const [textSent, setTextSent] = useState("");
    const [isActive, setIsActive] = useState(false);
    const [emailIsActive, setIsEmailActive] = useState(false);
    const [smsIsActive, setIsSmsActive] = useState(false);
    const changeField = ({ target: { name, value } }) => {
        setFields({
            ...fields,
            [name]: value,
        });
    };
    const ValidateEmail = (mail) => {
        if (mail == "") {
            Toast(ct("messages.emailRequired", "messages"), Constant.App.ToastTime.LongCloseTime);
            return false;
        }
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
            return true;
        }
        Toast(ct("messages.invalidEmail", "messages"), Constant.App.ToastTime.LongCloseTime);
        return false;
    };
    const sendEmail = () => {
        if (!ValidateEmail(fields.email)) {
            return;
        }
        // CUSTOM
        if (!checkSubscription()) {
            handleSubscription();
            return false;
        }
        // END
        setFields({
            ...fields,
            isEmailLoading: true,
        });
        const data = {
            url: inviteUrl || window.location.href,
            email: fields.email,
            room: lastSeg,
        };
        // API hit to claim room
        axios
            .post(`${socket_endpoint + apiVersion}/send_join_link`, data, config)
            .then((response) => {
            setFields({
                ...fields,
                isEmailLoading: false,
                email: "",
            });
            if (response.data.status) {
                console.log("email sent ");
                setEmailSent(ct("messages.emailSendSuccess", "messages"));
                setTimeout(function () {
                    setEmailSent("");
                }, 5000);
                // Toast(messages.emailSendSuccess, Constant.App.ToastTime.LongCloseTime);
                sendAnalytics({
                    action: "toolbar-clicked",
                    category: "toolbar",
                    source: "add participants send email",
                });
            }
            else {
                Toast(ct("messages.emailOrTextSendError", "messages"), Constant.App.ToastTime.LongCloseTime);
            }
        })
            .catch((error) => {
            Toast(ct("messages.contactAdmin", "messages"), Constant.App.ToastTime.LongCloseTime);
        });
    };
    const sendSMS = () => {
        if (fields.number == "") {
            Toast(ct("messages.phoneRequired", "messages"), Constant.App.ToastTime.LongCloseTime);
            return;
        }
        if (!fields.number || fields.number.indexOf("_") !== -1) {
            Toast(ct("messages.verifyContact", "messages"), Constant.App.ToastTime.LongCloseTime);
            return;
        }
        // CUSTOM
        if (!checkSubscription()) {
            handleSubscription();
            return false;
        }
        // END
        setFields({
            ...fields,
            isTextLoading: true,
        });
        const data = {
            room: lastSeg,
            url: inviteUrl || window.location.href,
            number: fields.number,
        };
        // API hit to claim room
        axios
            .post(`${socket_endpoint + apiVersion}/send_text_message`, data, config)
            .then((response) => {
            setFields({
                ...fields,
                isTextLoading: false,
                number: "",
            });
            if (response.data.status) {
                setTextSent(ct("messages.textSendSuccess", "messages"));
                setTimeout(function () {
                    setTextSent("");
                }, 5000);
                // Toast(messages.textSendSuccess, Constant.App.ToastTime.LongCloseTime);
                sendAnalytics({
                    action: "toolbar-clicked",
                    category: "toolbar",
                    source: "add participants send text",
                });
            }
            else {
                Toast(ct("messages.emailOrTextSendError", "messages"), Constant.App.ToastTime.LongCloseTime);
            }
        })
            .catch((error) => {
            Toast(ct("messages.contactAdmin", "messages"), Constant.App.ToastTime.LongCloseTime);
        });
    };
    // END
    /**
     * Copies the conference invitation to the clipboard.
     *
     * @returns {void}
     */
    function _onCopyText() {
        // CUSTOM
        if (!checkSubscription()) {
            handleSubscription();
            return false;
        }
        // END
        copyText(inviteText);
    }
    /**
     * Copies the conference invitation to the clipboard.
     *
     * @param {Object} e - The key event to handle.
     *
     * @returns {void}
     */
    function _onCopyTextKeyPress(e) {
        if (e.key === " " || e.key === "Enter") {
            e.preventDefault();
            copyText(inviteText);
        }
    }
    // CUSTOM
    function _onSendInviteByEmail() {
        setIsEmailActive(!emailIsActive);
    }
    function _onSendInviteBySms() {
        setIsSmsActive(!smsIsActive);
    }
    function _onToggleActiveState() {
        setIsActive(!isActive);
    }
    function _onToggleActiveStateKeyPress(e) {
        if (e.key === " " || e.key === "Enter") {
            e.preventDefault();
            setIsActive(!isActive);
        }
    }
    function renderNumberField() {
        return (React.createElement(React.Fragment, null, React.createElement("div", { className: "email-sms color-white" },
            React.createElement("label", { htmlFor: "number" },
                ct("rta-trmc.rtaInviteModal.sendTextMsg"),
                ":"),
            React.createElement("br", null),
            React.createElement("div", { className: "sms-text text_field" },
                React.createElement(InputMask, { id: "number", name: "number", type: "text", value: fields.number, onChange: changeField, mask: "(999) 999-9999", placeholder: "(999) 999-9999", className: "form-control", autoComplete: "off" }),
                !fields.isTextLoading ? (
                // <Button className="submit-button join-meeting-pass" onClick={sendSMS}>
                React.createElement(Button, { className: "submit-button join-meeting-pass", onClick: sendSMS }, ct("rta-trmc.rtaInviteModal.sendTextBtn"))) : (React.createElement(Button, { className: "submit-button join-meeting-pass" },
                    ct("rta-trmc.rtaInviteModal.sendTextBtn"),
                    React.createElement(Spinner, { testId: "email-invite-loader", size: "small" }),
                    " ")),
                textSent ? (React.createElement("span", { style: { color: "#27fe29" }, className: "ml-2" }, textSent)) : ("")))));
    }
    function renderEmailField() {
        return (React.createElement(React.Fragment, null, React.createElement("div", { className: "email-text text_field color-white" },
            React.createElement("label", { htmlFor: "email" },
                ct("rta-trmc.dialogs.email"),
                " : "),
            React.createElement("br", null),
            React.createElement("input", { id: "email", name: "email", type: "text", value: fields.email, onChange: changeField, className: "form-control", autoComplete: "off" }),
            !fields.isEmailLoading ? (
            // <Button className="submit-button join-meeting-pass" onClick={sendEmail}>
            React.createElement(Button, { className: "submit-button join-meeting-pass", onClick: sendEmail }, ct("rta-trmc.rtaInviteModal.sendEmail"))) : (React.createElement(Button, { className: "submit-button join-meeting-pass" },
                ct("rta-trmc.rtaInviteModal.sendEmail"),
                " ",
                React.createElement(Spinner, { testId: "email-invite-loader", size: "small" }),
                " ")),
            emailSent ? (React.createElement("span", { style: { color: "#27fe29" }, className: "ml-2" }, emailSent)) : (""))));
    }
    // END
    /**
     * Renders clickable elements that each open an email client
     * containing a conference invite.
     *
     * @returns {ReactNode}
     */
    function renderEmailIcons() {
        const PROVIDER_MAPPING = [
            {
                icon: IconEnvelope,
                tooltipKey: "addPeople.defaultEmail",
                url: `mailto:?subject=${encodedInviteSubject}&body=${encodedDefaultEmailText}`,
                // CUSTOM
                isShow: true,
                // END
            },
            {
                icon: IconGoogle,
                tooltipKey: "addPeople.googleEmail",
                url: `https://mail.google.com/mail/?view=cm&fs=1&su=${encodedInviteSubject}&body=${encodedInviteText}`,
                // CUSTOM
                isShow: !isSocialMobileApp(),
                // END
            },
            {
                icon: IconOffice365,
                tooltipKey: "addPeople.outlookEmail",
                // eslint-disable-next-line max-len
                url: `https://outlook.office.com/mail/deeplink/compose?subject=${encodedInviteSubject}&body=${encodedInviteText}`,
                // CUSTOM
                isShow: true,
                // END
            },
            {
                icon: IconYahoo,
                tooltipKey: "addPeople.yahooEmail",
                url: `https://compose.mail.yahoo.com/?To=&Subj=${encodedInviteSubject}&Body=${encodedInviteText}`,
                // CUSTOM
                isShow: true,
                // END
            },
        ];
        return (React.createElement(React.Fragment, null, 
        // CUSTOM
        // PROVIDER_MAPPING.map(({ icon, tooltipKey, url }, idx) => {
        PROVIDER_MAPPING.map(({ icon, tooltipKey, url, isShow }, idx) => {
            if (!isShow) {
                return null;
            }
            // END
            return (React.createElement(CustomMuiTooltip, { content: t(tooltipKey), key: idx },
                React.createElement("a", { "aria-label": t(tooltipKey), 
                    //CUSTOM
                    className: "provider-icon", 
                    // href={url}
                    onClick: (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (!checkSubscription()) {
                            handleSubscription();
                            return false;
                        }
                        else {
                            window.open(url, "_blank");
                        }
                    }, 
                    //END
                    rel: "noopener noreferrer", target: "_blank" },
                    React.createElement(Icon, { src: icon }))));
        })));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", null,
            React.createElement("div", { "aria-expanded": emailIsActive, "aria-label": ct("Translate.typography.inviteByEmail"), 
                //END
                className: `invite-more-dialog email-container${emailIsActive ? " active" : ""}`, onClick: _onSendInviteByEmail, role: "button", tabIndex: 0 },
                React.createElement("span", null, ct("Translate.typography.inviteByEmail")),
                React.createElement(Icon, { src: IconArrowDownSmall })),
            React.createElement("div", { className: `invite-more-dialog icon-container${emailIsActive ? " active" : ""}` }, renderEmailField()),
            React.createElement("div", { "aria-expanded": smsIsActive, "aria-label": ct("Translate.typography.inviteBySMS"), 
                //   END
                className: `invite-more-dialog email-container${smsIsActive ? " active" : ""}`, onClick: _onSendInviteBySms, role: "button", tabIndex: 0 },
                React.createElement("span", null, ct("Translate.typography.inviteBySMS")),
                React.createElement(Icon, { src: IconArrowDownSmall })),
            React.createElement("div", { className: `invite-more-dialog icon-container${smsIsActive ? " active" : ""}` }, renderNumberField()),
            !isSocialMobileApp() && !isMobileBrowserC() && !isIpad() && (React.createElement("div", { "aria-expanded": isActive, "aria-label": t("addPeople.shareInvite"), className: `invite-more-dialog email-container${isActive ? " active" : ""}`, onClick: _onToggleActiveState, onKeyPress: _onToggleActiveStateKeyPress, role: "button", tabIndex: 0 },
                React.createElement("span", null, t("addPeople.shareInvite")),
                React.createElement(Icon, { src: IconArrowDownSmall }))),
            React.createElement("div", { className: `invite-more-dialog icon-container${isActive ? " active" : ""}` },
                React.createElement(CustomMuiTooltip, { content: t("addPeople.copyInvite") },
                    React.createElement("div", { "aria-label": t("addPeople.copyInvite"), className: "copy-invite-icon", 
                        // eslint-disable-next-line react/jsx-no-bind
                        onClick: _onCopyText, 
                        // eslint-disable-next-line react/jsx-no-bind
                        onKeyPress: _onCopyTextKeyPress, role: "button", tabIndex: 0 },
                        React.createElement(Icon, { src: IconCopy }))),
                renderEmailIcons()))));
}
export default InviteByEmailSection;
